import Button, { ButtonProps } from '@mui/material/Button';
import React from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../contexts/auth-context';
import { AgtStaffPermissions, EventData } from '../types';

export function PurchaseTickets(props: {
  data: EventData;
  buttonText?: string;
  size?: ButtonProps['size'];
}) {
  // Context
  const {
    state: { session },
  } = React.useContext(AuthContext);

  const isAgtStaff = session?.getAccessToken().decodePayload()['myStaffForAgt'];
  const staffPerms =
    session?.getAccessToken().decodePayload()['cognito:groups'] || [];
  const canPurchase = isAgtStaff
    ? staffPerms.includes(AgtStaffPermissions['Wallet'])
    : true;

  if (canPurchase) {
    return (
      <Button
        size={props.size}
        disableElevation
        variant="contained"
        color="secondary"
        component={Link}
        to={`/events/${props.data.EventCode}/register`}
      >
        {props.buttonText || 'Buy Tickets'}
      </Button>
    );
  } else {
    return null;
  }
}
